import { render, staticRenderFns } from "./DomainCard.vue?vue&type=template&id=1414f67e&scoped=true&"
import script from "./DomainCard.vue?vue&type=script&lang=js&"
export * from "./DomainCard.vue?vue&type=script&lang=js&"
import style0 from "./DomainCard.vue?vue&type=style&index=0&id=1414f67e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1414f67e",
  null
  
)

export default component.exports